import { render, staticRenderFns } from "./SearchResultPlaceholders.vue?vue&type=template&id=480c8b8e&scoped=true"
import script from "./SearchResultPlaceholders.vue?vue&type=script&lang=js"
export * from "./SearchResultPlaceholders.vue?vue&type=script&lang=js"
import style0 from "./SearchResultPlaceholders.vue?vue&type=style&index=0&id=480c8b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c8b8e",
  null
  
)

export default component.exports